jQuery(document).ready(function(){
  // Build gallery items from the currently visible #bg-hero
  function buildGalleryItems() {
    const visibleBgHero = document.querySelector('.bg-hero:not(.hide)');
    if (!visibleBgHero) {
      console.warn('No visible .bg-hero found');
      return [];
    }
  
    const mediaSlides = Array.from(visibleBgHero.querySelectorAll('.swiper-slide.product_media_list'));
  
    mediaSlides.forEach((slide, index) => {
      slide.setAttribute('data-slide', index);
    });
  
    return mediaSlides.map(slide => {
      const img = slide.querySelector('img');
      const video = slide.querySelector('video');
  
      /* if (img && img.src && img.complete && img.naturalWidth > 0) {
        // Extract base URL (strip query string)
        const baseUrl = img.src.split('?')[0];
        const srcsetSizes = [400, 600, 800, 1000, 1200];
        const srcset = srcsetSizes
          .map(w => `${baseUrl}?width=${w} ${w}w`)
          .join(', ');
      
        const isMobile = window.innerWidth < 768;
        const displayWidth = isMobile ? window.innerWidth : img.naturalWidth;
        const displayHeight = isMobile ? (img.naturalHeight * window.innerWidth) / img.naturalWidth : img.naturalHeight;
      
        return {
          src: img.src,
          w: displayWidth,
          h: displayHeight,
          el: img,
          type: 'image',
          srcset: srcset,
          sizes: '100vw' // Full viewport width for mobile
        };
      } */

      if (video) {
        const source = video.querySelector('source');
        if (source?.src) {
          return {
            html: `
              <div class="pswp__custom-video-wrapper" style="display: flex; align-items: center; justify-content: center; height: 100%;">
                <video controls autoplay muted playsinline style="max-height: 100%; max-width: 100%;">
                  <source src="${source.src}" type="video/mp4">
                </video>
              </div>
            `,
            type: 'html'
          };
        }
      }

      if (img && img.src && img.complete && img.naturalWidth > 0) {
        const isMobile = window.innerWidth < 768;
        const displayWidth = isMobile ? window.innerWidth : img.naturalWidth;
        const displayHeight = isMobile ? (img.naturalHeight * window.innerWidth) / img.naturalWidth : img.naturalHeight;
      
        return {
          src: img.src, // Full-size original image URL
          w: displayWidth,
          h: displayHeight,
          el: img,
          type: 'image'
          // Removed srcset and sizes
        };
      }
  
      return null;
    }).filter(Boolean);
  }
  
  function openPhotoSwipe(startIndex = 0) {
    const galleryItems = buildGalleryItems();
    if (!galleryItems.length || !galleryItems[startIndex]) {
      console.warn('No valid gallery items found at index', startIndex);
      return;
    }
  
    const startItem = galleryItems[startIndex];
  
    const pswp = new PhotoSwipe({
      dataSource: galleryItems,
      index: startIndex,
      showHideAnimationType: startItem.type === 'image' ? 'zoom' : 'fade',
      thumbBounds: () => {
        if (startItem.type === 'image' && startItem.el instanceof HTMLElement) {
          startItem.el.scrollIntoView({ block: 'center', behavior: 'instant' });
          const rect = startItem.el.getBoundingClientRect();
          return {
            x: rect.left + window.scrollX,
            y: rect.top + window.scrollY,
            w: rect.width
          };
        }
        return null;
      }
    });
  
    // Hide built-in zoom button and handle custom zoom on tap
    pswp.on('uiRegister', () => {
      // Remove zoom button completely
      pswp.ui.registerElement({
        name: 'zoom-button',
        order: 8,
        isButton: true,
        className: 'pswp__button--zoom hidden',
        html: ''
      });
  
      // Add pagination UI
      pswp.ui.registerElement({
        name: 'custom-pagination-bar',
        order: 9,
        isButton: false,
        appendTo: 'wrapper',
        html: `
          <div class="pswp-custom-pagination">
            <button class="custom-prev">‹</button>
            <span class="custom-index">1 / ${galleryItems.length}</span>
            <button class="custom-next">›</button>
          </div>
        `,
        onInit: (el, pswpInstance) => {
          const indexEl = el.querySelector('.custom-index');
          const prevBtn = el.querySelector('.custom-prev');
          const nextBtn = el.querySelector('.custom-next');
  
          const update = () => {
            indexEl.textContent = `${pswpInstance.currIndex + 1} / ${pswpInstance.getNumItems()}`;
          };
  
          prevBtn.addEventListener('click', () => pswpInstance.prev());
          nextBtn.addEventListener('click', () => pswpInstance.next());
          pswpInstance.on('change', update);
          update();
        }
      });
    });
  
    // Enable zoom toggle when user taps image
    pswp.on('contentTapAction', (e, point, item) => {
      if (item.type === 'image') {
        const zoomLevel = pswp.currSlide.zoomLevel;
        const newZoom = zoomLevel === pswp.currSlide.initialZoomLevel
          ? pswp.currSlide.zoomLevels.max
          : pswp.currSlide.initialZoomLevel;
  
        pswp.currSlide.zoomTo(newZoom, { x: point.x, y: point.y }, 300);
      }
    });
  
    pswp.init();
  }


  // Handle zoom button click
  $(document).on('click', '#enable-zoom', function () {
    const slideIndexStr = $(this).closest('.product_media_list').attr('data-slide');
    const slideIndex = parseInt(slideIndexStr, 10);

    if (!isNaN(slideIndex)) {
      openPhotoSwipe(slideIndex);
    } else {
      console.warn('Invalid or missing data-slide attribute');
    }
  });
  
})

 $(document).on('click', '.enable-zoom', function () {

    const image = $(this)
        .closest('.product_meta_size_images')
        .find('.meta_size_guide_image');

    if (image.length) {

       const imageSrc = image
    .attr('src')
    .replace(/width=\d+/g, 'width=1200');

        // Remove existing popup if already open
        $('.custom-image-zoom-popup').remove();

        // Create popup HTML
        const popup = `
            <div class="custom-image-zoom-popup">
                <button class="custom-image-close">&times;</button>
                <img src="${imageSrc}" class="custom-image-zoomed" alt="Zoom Image">
            </div>
        `;

        // Append popup to body
        $('body').append(popup);
    }

});
$(document).on('click', '.custom-image-close, .custom-image-zoom-popup', function (e) {

    // Prevent closing when clicking image
    if ($(e.target).hasClass('custom-image-zoomed')) {
        return;
    }

    $('.custom-image-zoom-popup').remove();

});